import convertTimestampToShamsi from '@/common/utils/convertTimestampToShamsi';
import { VisitInformationTypeParams } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVisitInformation/getVisitInformationQuer.type';
import { VisitOtherInformationResponseType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVisitOtherDamagedInformation/getVisitOtherDamagedInformationQuer.type';
import { getVisitOtherInformationQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVisitOtherDamagedInformation/getVisitOtherDamagedInformationQueryFunction';
import { queryOptions } from '@tanstack/react-query';

const getVisitShowOtherInformationQueryOption = (
  params: VisitInformationTypeParams,
) =>
  queryOptions({
    queryKey: ['get_vehicle_damage_amount', params],
    queryFn: () => getVisitOtherInformationQueryFunction(params),
    select: (data: VisitOtherInformationResponseType) => {
      return {
        visitInformation: [
          {
            label: 'تاریخ بازدید :',
            value: data?.visit_date
              ? convertTimestampToShamsi(+data?.visit_date)
              : '',
          },
          { label: 'ساعت بازدید :', value: data?.visit_time?.toString() },
          { label: 'تعداد بازدید :', value: data?.visit_number?.toString() },
          {
            label: 'محل بازدید :',
            value: data?.visit_site?.fa_const?.toString(),
          },
          { label: 'مسافت طی شده :', value: data?.distance?.toString() },
          {
            label: 'آدرس محل بازدید :',
            value: data?.visit_location?.toString(),
          },
        ],
      };
    },
  });
export default getVisitShowOtherInformationQueryOption;
